
import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { FaDownload, FaTrash } from "react-icons/fa";
import Const from '../../util/Constants';
import DocumentAPI from '../../api/DocumentAPI';
import Util from '../../util/Util';
import Display from '../../util/Display';
import ApiUiController from '../../controller/ApiUiController';
import "./InnerDocumentList.css";
import { DocTable, MyGallery } from "./ImageGalleryComponent";
import ShareComponent from "./ReactSocialShare.js";
import PropertyAPI from "../../api/PropertyAPI.js";

class InnerDocumentList extends React.Component {
  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).document;
    this.state = { inApiCall: true, documents: [], encryptedText: '' };
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
    this.package = reactLocalStorage.getObject(Const.LoggedInUser).package;
  }

  componentDidMount() {
    if (this.props.type && this.props.id) {
      DocumentAPI.getInnerList(this.props.type, this.props.id, this.onReceived, this.onFail);
    }
    this.getEncryptedKey();
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.id !== this.props.id) {
      this.setState({ ...this.state, inApiCall: true, documents: [] });
      if (this.props.type && props.id) {
        DocumentAPI.getInnerList(this.props.type, props.id, this.onReceived, this.onFail);
      }
    }
  }

  onFail = res => this.setState({ ...this.state, inApiCall: false });
  onReceived = res => {
    if (this.props.onCount) {
      this.props.onCount('document', res.count);
    }
    this.setState({ inApiCall: false, documents: res.data });
  };

  onDownload = async (index, position) => {
    const doc = this.state.documents[index];
    const files = doc.files.substring(1, doc.files.length - 1).split(Const.Opt);
    const res = await DocumentAPI.getPublicMediaUrl(files[position]);
    window.open(res.url, "_blank");
  };

  onDelete = (indx) =>
    Util.confirmAlert(
      "Delete",
      "Are you sure you want to delete",
      "Delete",
      "No",
      () => {
        this.setState({ ...this.state, inApiCall: true });
        DocumentAPI.delete(
          this.state.documents[indx].id,
          this.onDeleteSuccess,
          this.onFail
        );
      }
    );

  onDeleteSuccess = () => {
    Util.showNotification(
      "Successful",
      "Document deleted successfully",
      "success"
    );
    this.props.reload();
  };

  showList = () => {
    const docs = [];
    for (let i = 0; i < this.state.documents.length; i++) {
      const doc = this.state.documents[i];
      const files = doc.images;
      if (files.length === 0) {
        continue;
      }
      docs.push(
        <tr key={`document_${i + 1}`}>
          <td>{Util.serverStringToDisplayDateTime(doc.created_date)}</td>
          <td>{Display.FieldValue(doc, "file_type", this.model.fields)}</td>
          <td>{Display.FieldValue(doc, "description", this.model.fields)}</td>
          <td>
            {files.map((file, j) => (
              <a
                key={`doc_${i}_${j}`}
                className="buttons add"
                href={file.url}
                target="_blank"
                rel="noreferrer">
                <FaDownload /> Download
              </a>
            ))}
          </td>
          <td>{Display.ModelLabelValue("user", doc.created_by)}</td>
          <td>
            {this.Delete && (
              <span onClick={() => this.onDelete(i)} className="buttons delete">
                <FaTrash /> Delete
              </span>
            )}
          </td>
        </tr>
      );
    }
    return docs;
  };

  getEncryptedKey = async () => {
    const data = { "id": this.props.id };
    const { encryptedText } = await PropertyAPI.getEncryptedKey(data) || {};
    this.setState({ encryptedText });
  };

  render() {
    let images = [], videos = [], document = [], videoLinks = [];
    this.state.documents.forEach((item) => {
      if (item.link !== '' && item.link !== null) {
        videoLinks.push(item.link);
      }
      item.images.forEach((image) => {
        if (Const.FileUploadType[0].includes(image.file_type)) images.push({
          ...image,
          document_id: item?.id
        });
        else if (Const.FileUploadType[1].includes(image.file_type)) videos.push({
          ...image,
          document_id: item?.id
        });
        else if (Const.FileUploadType[2].includes(image.file_type)) document.push({
          ...image,
          document_id: item?.id
        });
      });
    });

    const sefUrl = `www.orggenproperties.com/en/property?${this.state.encryptedText}`;
    return (
      <>
        <h2>{this.props.title ? this.props.title : "Documents"}</h2>
        <div className="row">
          <div className=" col-md-6">
            <ApiUiController inApiCall={this.state.inApiCall}>
              {this.state.documents.length > 0 &&
                this.state.documents[0].images ? (
                <div className=" rounded p-2">
                  {/* React Image Gallery */}
                  <MyGallery media={images} documents={this.state.documents} className={"images"} reload={this.props.reload} canDelete={this.Delete} />
                </div>
              ) : <div className="text-left p-2"><p>No Images Available</p></div>}
            </ApiUiController>
          </div>
          {this.package === Const.Enterprise && <div className=" col-md-6">
            {/* Share buttons with styling */}
            <ShareComponent propertyUrl={sefUrl} />
            {/* <img src={qrUrl} alt="QR Code" className="mx-auto" /> */}
          </div>}
        </div>
        <div className="row">
          <div className="col-md-6">
            <h2>Videos</h2>
            <div>
              <ApiUiController inApiCall={this.state.inApiCall}>
                {this.state.documents.length > 0 &&
                  this.state.documents[0].images ? (
                  <div className=" rounded p-2">
                    {/* React Image Gallery */}
                    <MyGallery media={videos} documents={this.state.documents} className={"Videos"} reload={this.props.reload} links={videoLinks} canDelete={this.Delete} />
                  </div>
                ) : <div className="text-left p-2"><p>No Videos Available</p></div>}
              </ApiUiController>
            </div>
          </div>
          <div className="col-md-6">
            <h2 className="p-4">Documents</h2>
            <div>
              <ApiUiController inApiCall={this.state.inApiCall}>
                <DocTable media={document} documents={this.state.documents} reload={this.props.reload} />
              </ApiUiController>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default InnerDocumentList;
